export const isFullWidthWindow = (): boolean => {
  const innerWidthInCssPx =
    window.innerWidth || document.documentElement.clientWidth;
  const zoom =
    Number(
      window.getComputedStyle(document.documentElement).getPropertyValue('zoom')
    ) || 1;

  // the reason for doing this is that innerWidth value is in css pixels
  // and when user zooms in/out - it descreses/increases respectively
  // however this property is supported only by Chrome (which is majority of users)
  const innerWidth = innerWidthInCssPx * zoom;

  // to avoid inaccuracy after multiplying
  return Math.round(window.outerWidth) === Math.round(innerWidth);
};
